export default __webpack_public_path__ + "static/media/creamcshare.27af42db.png";